import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { PolicyGuard } from '@core/guards/policy.guard';
import { authMatchGuard } from '@core/guards/auth-match.guard';

/** Replaced by prototypes.entry.disabled.ts in production/uat/hlg builds (angular.json fileReplacements). */
export const PROTOTYPES_APP_ROUTES: Routes = [
  {
    path: 'prototipos',
    canActivate: [AuthGuard, PolicyGuard],
    canMatch: [authMatchGuard],
    loadChildren: () => import('./prototypes.routes').then(m => m.prototypesRoutes),
  },
];
